import React from "react";
import "./RevenueChart.css";

import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const RevenueChart = ({ revenue }) => {
  const chartData = months.map((month, index) => {
    const found = revenue.find(
      (item) => item._id.month === index + 1
    );

    return {
      month,
      revenue: found ? found.revenue : 0,
      orders: found ? found.orders : 0,
    };
  });

  const totalRevenue = chartData.reduce(
    (sum, item) => sum + item.revenue,
    0
  );

  return (
    <div className="revenue-chart">

      <div className="revenue-header">

        <div>
          <h2>Revenue Overview</h2>
          <p>Monthly revenue generated</p>
        </div>

        <div className="revenue-total">
          ₹{totalRevenue.toLocaleString()}
        </div>

      </div>

      <ResponsiveContainer
        width="100%"
        height={350}
      >
        <BarChart data={chartData}>

          <CartesianGrid strokeDasharray="3 3" />

          <XAxis dataKey="month" />

          <YAxis />

          <Tooltip />

          <Legend />

          <Bar
            dataKey="revenue"
            name="Revenue"
            radius={[8, 8, 0, 0]}
          />

        </BarChart>
      </ResponsiveContainer>

    </div>
  );
};

export default RevenueChart;